import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  Stack,
  Radio,
  Tooltip,
  Container,
  Typography,
  RadioGroup,
  CardActionArea,
  FormControlLabel,
} from '@mui/material';
// components
import { useSettingsContext } from '../../../components/minimal/settings/index.jsx';
import Image from '../../../components/minimal/image/index.jsx';
import Iconify from '../../../components/minimal/iconify/index.jsx';
import { MotionViewport, varFade } from '../../../components/minimal/animate/index.jsx';

import ImgA from '../../../assets/images/home/presets_block_purple.png'
import ImgB from '../../../assets/images/home/presets_chart_purple.png'
import ImgC from '../../../assets/images/home/presets_screen_purple.png'
import ImgD from '../../../assets/images/home/presets_sidebar_purple.png'
import ImgE from '../../../assets/images/home/presets_grid.png'

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(10, 0, 0, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(15, 0, 0, 0),
  },
}));

// ----------------------------------------------------------------------

export default function HomeColorPresets() {
  return (
    <StyledRoot sx={{ mt: 10 }}>
      <Container component={MotionViewport} sx={{ position: 'relative' }}>
        <Stack spacing={3} sx={{ textAlign: 'center' }}>

          <m.div variants={varFade().inDown}>
            <Typography variant="h4">
              מערכת CRM אינטגרלית וניהול כספים (קבלה ושליחת תשלום) מתוך המערכת
            </Typography>
          </m.div>
        </Stack>

        <Box sx={{ position: 'relative' }}>
          <Image disabledEffect alt="grid" src={ImgE} />

          <Box sx={{ position: 'absolute', top: 0 }}>
            <m.div variants={varFade().inUp}>
              <Image
                  disabledEffect
                  alt="screen"
                  src={ImgC}
              />
            </m.div>
          </Box>

          <Box sx={{ position: 'absolute', top: 0 }}>
            <m.div variants={varFade().inDown}>
              <m.div animate={{ y: [0, -15, 0] }} transition={{ duration: 8, repeat: Infinity }}>
                <Image
                    disabledEffect
                    alt="sidebar"
                    src={ImgA}
                />
              </m.div>
            </m.div>
          </Box>

          <Box sx={{ position: 'absolute', top: 0 }}>
            <m.div variants={varFade().inDown}>
              <m.div animate={{ y: [-5, 10, -5] }} transition={{ duration: 8, repeat: Infinity }}>
                <Image
                    disabledEffect
                    alt="sidebar"
                    src={ImgB}
                />
              </m.div>
            </m.div>
          </Box>

          <Box sx={{ position: 'absolute', top: 0 }}>
            <m.div variants={varFade().inDown}>
              <m.div animate={{ y: [-25, 5, -25] }} transition={{ duration: 10, repeat: Infinity }}>
                <Image
                    disabledEffect
                    alt="sidebar"
                    src={ImgD}
                />
              </m.div>
            </m.div>
          </Box>
        </Box>

      </Container>
    </StyledRoot>
  );
}
